<template>
<div class="">
    <div class="card shadow mb-4">
        <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4 card-body">

                        <div class="dataTables_length table-filters" id="dataTable_length">

                            <!--<label>
                    Show
                    <select v-model="limit" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select> entries
                </label>-->
                            <div>           <!--    <div v-bind:class="{'opacity-quarter':query}">-->
                                <label v-if="users && !orgId" v-bind:class="{selectedFilter: assignedFilter !== 'all'}">Assigned:
                                    <select v-model="assignedFilter" @change="assignedChange($event)" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                        <option value="all">Any Users</option>
                                        <option :value="null">Unassigned</option>
                                        <option :value="user.name" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                    </select>
                                </label>
                                <label class="ml-3" v-if="!statusStep && !orgId" v-bind:class="{selectedFilter: statusFilter !== 'all'}">Status:
                                    <select @change="statusChange($event)" v-model="statusFilter" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                        <option value="all">Any Status</option>
                                        <option>Created</option>
                                        <option>Container/eCubes Deployed</option>
                                        <option>Pickup Booked</option>
                                        <option>Transfer</option>
                                        <option>Inwards Recorded</option>
                                        <option>Shred/NZISM</option>
                                        <option>Data Destruction Complete</option><option>Dropping Off</option>
                                        <option>Teardown/Processing</option>
                                        <option>Finalise</option>
                                        <option>Invoice</option>
                                    </select>
                                </label>
                                <label class="ml-3" for="picker" v-if="users && !orgId" v-bind:class="{selectedFilter: dateRange.startDate !== null && dateRange.endDate !== null}">Date Range:
                                    <date-range-picker ref="picker" opens="center" :maxDate="maxDate" v-model="dateRange">
                                        <template v-slot:input="picker" style="min-width: 350px;">
                                            {{ picker.startDate | date  }} - {{ picker.endDate | date  }}
                                        </template>
                                    </date-range-picker>
                                </label>
                                <button v-if="dateRange.startDate !== null || dateRange.endDate !== null" @click="clearDateRange()" class="ml-1 btn btn-sm btn btn-outline-secondary">Clear</button>

                                <div v-if="!statusStep" style="display: inline-block;" class="ml-4  custom-control custom-checkbox small">
                                    <input v-model="showCompleted" type="checkbox" class="custom-control-input" id="customCheck" />
                                    <label class="custom-control-label" for="customCheck">Show Completed</label>
                                </div>
                                <div class="ml-3"  v-if="(dateRange.startDate !== null && dateRange.endDate !== null && showCompleted) || statusFilter !== 'all' || (assignedFilter !== 'all' && showCompleted)" style="display: inline-block;" id="dataTable_paginate">
                                     <button v-if="user && user.data && user.data.role > 8" @click="downloadCSV(jobs)" class="btn btn-sm btn-info"><i class="fas fa-fw fa-file-excel"></i> Download CSV</button>
                                </div>
                            </div>
                             <!--<div  v-if="query" style="display: inline-block;"  class="mb-2" id="dataTable_paginate">
                                     <button v-if="user && user.data && user.data.role > 8" @click="downloadCSV(hits)" class="btn btn-sm btn-info"><i class="fas fa-fw fa-file-excel"></i> Download CSV</button>
                                </div>
                            <ais-search-box style="margin-left:auto;" placeholder="Search Jobs" submit-title="Search" reset-title="Remove the query">
                                <debounced-search-box :hitsAmount="hits.length" :result="query" :delay="200" />
                            </ais-search-box>-->
                                <div id="dataTable_filter" style="max-width:280px;margin-bottom: 0.5rem;" class="dataTables_filter input-group"><input type="text" v-model="searchText" placeholder="Search by Job# or Email" aria-label="Search" v-on:keyup.enter="search()" class="form-control ">
                                    <div class="input-group-append"><button @click="search()" type="button" class="btn btn-primary"><i class="fas fa-search fa-sm"></i></button></div>
                                </div>

                        </div>

                        <div class="table-responsive-xl">
                            <div>
                                <table class="fixed selectable">
                                    <thead>
                                        <tr>
                                         <th class="col-date" v-if="statusStep">Completed</th>
                                            <th class="col-date">Job Created</th>
                                            <th class="col-job">Job#</th>
                                            <th>Business</th>
                                            <th>Name</th>
                                            <th class="col-status" v-if="!statusStep">Status</th>
   
                                            <th class="col-address">Address</th>
                                            <th class="col-job">Assigned</th>
                                            <th class="col-job" v-if="!orgId">Flags</th>
                                            <th class="col-job" v-if="orgId">Hours</th>
                                            <th class="col-arrow"> </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(job, index) in jobs">
                                        <router-link v-if="(statusStep && job.status === 'Completed') || (!statusStep && job.status !== 'Completed') || showCompleted" v-bind:class="{disable: job.status==='Cancelled'}" class="rw" tag="tr" :to="{ name: 'job-archive-view', params: { id: $options.filters.jobid(job.jobid), key: job['.key'] } }" v-bind:key="index">
                                                    
                                            <td class="col-date" v-if="statusStep">{{job.statusChangeDate | oldDate}}</td>   
                                                    
                                            <td class="col-date" :time="job.submitted">{{job.submitted | oldDate}}</td>
                                            <td class="col-job">{{job.jobid | jobid}}</td>
                                            <td>{{job.company}}</td>

                                            <td :title="job.name + ' (' + job.email + ')'">{{job.name}} <small>({{job.email}})</small></td>
                                            <td class="col-status py-1" v-if="!statusStep">
                                                <span style="margin:auto 0;"  :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span>
                                                <small v-if="job.statusChangeDate" style="color:#777;font-size: 11px; display: block; margin-top: 0px; margin-bottom: -2px;">Change: {{job.statusChangeDate | shortDate}}</small>
                                            </td>
  

                                            
                                            <td class="col-address">{{job.address}}</td>
                                            <td class="col-job py-1">
                                                <div v-html="$options.filters.getCaps(job.assignedTo, job.assignedUID, users)"></div>
                                            </td>
                                            <td class="col-job" v-if="!orgId"><i title="Admin Attachment(s)" v-if="job.adminAttachments && job.adminAttachments.length > 0" class="text-info fas fa-fw fa-file"></i><i title="Inward Goods Received" v-if="job.inwards && job.inwards.length > 0" class="text-secondary fas fa-fw fa-truck"></i><i :title="job.datadestruction + ' Data Destruction'" v-if="job.datadestruction !== 'No'" class="text-danger fas fa-fw fa-database"></i><i title="Covid Vax Required" v-if="job.covidvax === true" class="text-warning fas fa-fw fa-exclamation-triangle"></i></td>
                                            <td class="col-job" v-if="orgId"><span v-if="job.totalHours">{{job.totalHours}}hrs</span></td>
                                            
                                            
                                            <!-- <td>
            <div class="nav-item dropdown dropdown-hover">
              <button class="btn p-2 nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
              <div class="dropdown-menu dropdown-menu-right animated--fade-in" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div>
          </td>-->
                                            <!--
              <td>{{job.accounts}}</td>
              <td>{{job.return}}</td>
              <td>{{}}</td>
                  <td><span v-for="(item, i) in job.items"  v-bind:key="i">{{item.description}}-{{item.quantity}}</span></td>-->
                                            <td class="col-arrow"><i class="fas fa-fw fa-chevron-right"> </i></td>
                                        </router-link>
                                        </template>
                                    </tbody>
                                    <tfoot v-if="orgId">
                                            <tr>
                                                <th style="text-align:right;" colspan="8">{{totalHours}}hrs</th>
                                                <td class="col-arrow"></td>
                                            </tr>
                                   </tfoot>
                                </table>
                            </div>
                        </div>
                        <div v-if="jobs.length >= limit" class="d-flex justify-content-center paging_simple_numbers" id="dataTable_paginate">
                            <button class="btn btn-outline-primary btn-center" @click="loadMore()">Load More</button>
                        </div>


    


        </div>
    </div>
</div>
</template>

<script>
import {
    db
} from "../main";

import {
    mapGetters
} from "vuex";

import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

//import algoliasearch from 'algoliasearch/lite';
//import 'instantsearch.css/themes/algolia-min.css';
//import DebouncedSearchBox from '@/components/DebouncedSearchBox';
import getOrganisation from "../mixins/getOrganisation";

const jobsRaw = db.ref("jobsArchive");

/*const algoliaClient = algoliasearch(
    'OS6EXBEUAB',
    'd97da9406933e349335792a9ba147300'
);

const searchClient = {
    async search(requests) {
        if (requests.every(({
                params: {
                    query
                }
            }) => Boolean(query) === false)) {
            return {
                results: requests.map(function(){
                    return {
                        processingTimeMS: 0,
                        nbHits: 0,
                        hits: [],
                        facets: {},
                    };
                }),
            };
        }
        return algoliaClient.search(requests);
    },
    async searchForFacetValues(requests) {
        return algoliaClient.searchForFacetValues(requests);
    },
};
*/
export default {
    name: "Archive",
    components: {
        DateRangePicker,
        //DebouncedSearchBox,
    },
    mixins: [getOrganisation],
    props: {
        statusStep: {
            type: String,
        }
    },

    data() {
        return {
            jobsRaw: [],
            limit: 50,
            //startAt: 0,
            maxLimit: 100000,
            endAt: 100000,
            pageNo: 1,
            searchText: '',
            opened: [],
            users: [],
            assignedFilter: "all",
            statusFilter: "all",
            dateRange: {
                startDate: null,
                endDate: null
            },
            showCompleted:false,
            maxDate: new Date(),
             /*searchClient,
            query: null,
              searchParameters: {
                    hitsPerPage: 4,
                    filters: undefined
                }*/
        };
    },
    filters: {
        date(date) {
            if (date) {
                return new Intl.DateTimeFormat("en-NZ").format(date);
            } else {
                return "Any Date"
            }
        }
    },
    computed: {
        ...mapGetters({
            user: "user",
            orgs: "orgs"
        }),
        jobs: function () {
            return [...this.jobsRaw].reverse();
        },
        orgId() {
            return this.org['.key']
        },
        combinedWatch() {
            return this.orgId + this.statusFilter + this.limit + this.assignedFilter + this.dateRange.startDate + this.dateRange.endDate; // + this.user.data.organisation;
        },
        totalHours: function () {
            return this.jobs.reduce(function (totalHours, item) {

                return parseFloat(totalHours + (item.totalHours ? item.totalHours : 0));
            }, 0);
        },
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
    mounted() {
        var filter = JSON.parse(sessionStorage.getItem('filter'));
        console.log('filter', filter);

        if (!this.statusStep && filter) {
            if (filter['dateRange']) {
                this.dateRange.startDate = new Date(filter.dateRange.startDate);
                this.dateRange.endDate = new Date(filter.dateRange.endDate);
                        console.log('dateRange', this.dateRange);

            } else if (filter['assignedFilter']) {
                this.assignedFilter = filter.assignedFilter;
                this.assignedChange();
            } else if (filter['statusFilter']) {
                this.statusFilter = filter.statusFilter;
                this.statusChange();
            }
        }
        //Completed Jobs page
        if (this.statusStep) {
            this.limit = 100;
            var completedfilter = JSON.parse(sessionStorage.getItem('completedfilter'));
             if (completedfilter) {
                this.dateRange.startDate = new Date(completedfilter.dateRange.startDate);
                this.dateRange.endDate = new Date(completedfilter.dateRange.endDate);
             }

        }

    },
    methods: {
        und(val){
            if(!val || val === 'undefined'){
                return '';
            }else{
                return String(val).replace(/"/g, '""');
            }
        },
        downloadCSV(items) {
            var t = this;
            let csvContent = "data:text/csv;charset=utf-8,";
            console.log('CSV items', items)

            csvContent += 'Date, Job ID, Status, Status Changed, Assigned To, Inwards Received, Data Destruction, Company,  Customer JobNo, Items, Customer Name,Phone,Email,Address,Accounts, Customer Message' + '\r\n';
            items.forEach(function (rw) {
                let row = '"' + t.$moment(rw['submitted']).format("DD/MM/YY h:mma") + '",';
                row += '"' + t.$options.filters.jobid(rw['jobid']) + '",';
                row += '"' + rw['status'] + '",';
                row += '"' + t.$moment(rw['statusChangeDate']).format("DD/MM/YY h:mma") + '",';
                row += '"' + t.und(rw['assignedTo']) + '",';
                if(rw['inwards']){
                    row += '"Yes",';
                }else{
                    row += '"",';
                }
                row += '"' + t.und(rw['datadestruction']) + '",';
                row += '"' + t.und(rw['company']) + '",';
                row += '"' + t.und(rw['custJob']) + '",';
                if(rw['itemoption'] === 'upload'){
                     row += '"' + 'https:/itrecycla.co.nz/wp-content/themes/blankslate/uploads/' + rw['attachment'] + '",';
                }else if(rw['items'] && rw['items'].length > 0){
                   var items = "";
                    for (const prop in rw['items']) {
                        console.log('prop', prop)
                        var propObj = rw['items'][prop];
                        items += propObj.description.replace(/"/g, '""') + ' - ' + propObj.quantity + ', ';
                    }

                    row += '"' + items.slice(0, -2) + '",';
                    console.log('items', items);
                }else{
                    row += '"",';
                }
                row += '"' + rw['name'] + '",';
                row += '"' + t.und(rw['phone']) + '",';
                row += '"' + rw['email'] + '",';
                row += '"' + rw['address'] + '",';
                row += '"' + t.und(rw['accounts']) + '",';
                row += '"' + t.und(rw['message']).replace(/"/g, '""') + '",';
                csvContent += row + '\r\n';
            });

            var encodedUri = encodeURI(csvContent).replaceAll('#', '%23');
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            
            //var branch = this.$options.filters.branchFilter(t.filters.branch);

            link.setAttribute("download", "jobslist-" + this.$moment(Date.now()).format("DDMMMYYYY") + ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        loadMore() {
            this.limit += 100;
        },
        nextEndAt() {
            this.pageNo += 1;
            this.startAt = this.jobs[0].jobid;
            this.endAt = this.jobs[this.jobs.length - 1].jobid;
            console.log(this.endAt);
        },
        search() {
            const t = this;
            var srch = t.searchText.trim();
            if (srch !== '') {
                console.log(srch);
                if (srch.indexOf("@") != -1) {
                    this.$router.push({
                        name: 'job-search',
                        query: {
                            email: srch
                        }
                    })
                } else {
                    var intSearch = parseInt(srch);
                    console.log(intSearch);
                    console.log(isNaN(intSearch));
                    if (typeof intSearch === "number") {
                        this.$router.push({
                            name: 'job-archive-view',
                            params: {
                                id: intSearch
                            }
                        })
                    }
                }
            }

        },
        prevEndAt() {
            this.pageNo -= 1;
            if (this.pageNo != 1) {
                this.endAt = this.startAt;
            } else {
                this.endAt = this.maxLimit;
            }
            //this.endAt = 100000;
            console.log(this.startAt);
        },
        changePage() {},
        statusChange() {
            if(this.statusFilter !== "all"){
                this.showCompleted = false;
            }
            this.assignedFilter = "all";
            this.clearDateRange()
        },
        clearDateRange(){
            this.dateRange = {
                startDate: null,
                endDate: null
            }
            if(this.statusStep){
                sessionStorage.removeItem('completedfilter');
                this.limit = 100;
            }else{
                sessionStorage.removeItem('filter');
                this.limit = 50;
            }


        },
        assignedChange() {
            this.statusFilter = "all";
            this.clearDateRange()
        }
    },
    watch: {
        combinedWatch: {
            // call it upon creation too
            immediate: true,
            handler() {
                /*if(this.user.data.organisation){
                    this.$rtdbBind(
                        "jobsRaw",
                        jobsRaw.orderByChild("organisation").equalTo(this.user.data.organisation.toString()).limitToLast(this.limit)
                    );
                }else */
                console.log('datChagne', this.dateRange)
                if (this.statusStep){  

                    if (this.dateRange.startDate !== null && this.dateRange.endDate !== null) {    
                        sessionStorage.setItem('completedfilter', JSON.stringify({
                            "dateRange": this.dateRange
                        }));
                        this.$rtdbBind(
                            "jobsRaw",
                            // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                            jobsRaw.orderByChild("statusChangeDate").startAt(this.dateRange.startDate.toISOString()).endAt(this.dateRange.endDate.toISOString()).limitToLast(this.limit)
                        );
                    }else{
                        this.$rtdbBind("jobsRaw", jobsRaw.orderByChild("statusChangeDate").limitToLast(this.limit));
                    }
                }else if (this.orgId) {
                    sessionStorage.setItem('filter', JSON.stringify({
                        "orgFilter": this.orgId
                    }));       
                    this.limit = 1000;
                    /*sessionStorage.setItem('filter', JSON.stringify({
                        "dateRange": this.dateRange
                    }));*/
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRaw.orderByChild("organisation").equalTo(this.orgId).limitToLast(this.limit)
                    );
                }else if (this.dateRange.startDate !== null && this.dateRange.endDate !== null) {
                    this.assignedFilter = "all";
                    this.statusFilter = "all";
                    console.log('dateStart', this.dateRange.startDate.toISOString());
                    this.limit = 10000;
                    sessionStorage.setItem('filter', JSON.stringify({
                        "dateRange": this.dateRange
                    }));
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRaw.orderByChild("submitted").startAt(this.dateRange.startDate.toISOString()).endAt(this.dateRange.endDate.toISOString()).limitToLast(this.limit)
                    );
                } else if (this.assignedFilter !== "all") {
                    sessionStorage.setItem('filter', JSON.stringify({
                        "assignedFilter": this.assignedFilter
                    }));
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRaw.orderByChild("assignedTo").equalTo(this.assignedFilter).limitToLast(this.limit)
                    );
                } else if (this.statusFilter !== "all") {

                        sessionStorage.setItem('filter', JSON.stringify({
                            "statusFilter": this.statusFilter
                        }));
   
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRaw.orderByChild("status").equalTo(this.statusFilter).limitToLast(this.limit)
                    );
                    
                } else {
                    //sessionStorage.removeItem('filter');


                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRaw.orderByChild("jobid").limitToLast(this.limit)
                    );

                }
            },
        },
    },
    /*firebase: {
      jobsRaw: db.ref('jobs2020').orderByChild('jobid').limitToLast(20),
    },*/
};
</script>

<style>
label.selectedFilter {
    font-weight: bold !important;

}

.selectedFilter .form-control {
    font-weight: bold !important;
}
</style>
